var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.365,
    height: 25.365,
    viewBox: "0 0 25.365 25.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report-projects",
    transform: "translate(-20.122 -10.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2952",
    "data-name": "Group 2952",
    transform: "translate(20.122 10.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2951",
    "data-name": "Group 2951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4406",
    "data-name": "Path 4406",
    d: "M52.4,31.01h9.254a1.306,1.306,0,0,0,1.279-1.43A11.754,11.754,0,0,0,52.627,19.2a1.306,1.306,0,0,0-1.43,1.279v9.254A1.206,1.206,0,0,0,52.4,31.01Z",
    transform: "translate(-37.576 -19.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4407",
    "data-name": "Path 4407",
    d: "M43.557,45.843A10.688,10.688,0,0,0,54.541,35.686a.593.593,0,0,0-.6-.6H44.986a1.157,1.157,0,0,1-1.129-1.129V25a.647.647,0,0,0-.6-.6,10.731,10.731,0,0,0,.3,21.443Z",
    transform: "translate(-33.095 -20.481)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportProjects);
export default __webpack_public_path__ + "static/media/report-projects.96e50560dbf784c7ed9add75e8699747.svg";
export { ForwardRef as ReactComponent };